import { render, staticRenderFns } from "./NewMedication.vue?vue&type=template&id=6a0fda6a&scoped=true"
import script from "./NewMedication.vue?vue&type=script&lang=js"
export * from "./NewMedication.vue?vue&type=script&lang=js"
import style0 from "./NewMedication.vue?vue&type=style&index=0&id=6a0fda6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0fda6a",
  null
  
)

export default component.exports